import moment from 'moment';

interface Venue {
    name: string;
    city: string;
    street_address: string;
    country: string;
}

interface Offer {
    url: string;
}

interface Event {
    venue: Venue;
    datetime: string;
    url: string;
    offers: Offer[];
}

interface ListingEvent {
    venueName: string;
    venueCity: string;
    venueStreet: string;
    venueCountry: string;
    date: string;
    url: string;
    ticket?: string;
}

const API = 'https://rest.bandsintown.com/artists/Paul%20Oakenfold/events?app_id=squarespace-conch-grey-f2c4&date=upcoming';

class Tour {
    namespace: HTMLElement | null;
    listingsWrapper: HTMLElement | null;

    constructor() {
        this.namespace = document.getElementById('page-tours');  
        this.listingsWrapper = null;

        this.initPage();
    }

    initPage(): void {
        if (!this.namespace) return;
        this.listingsWrapper = document.querySelector('.listings');
        this.getListings();
    } 

    getListings(): void {
        fetch(API)
        .then(response => response.json())
        .then((data: Event[]) => {
            this.renderListings(data);
        });
    }

    renderListings(data: Event[]): void {
        data.forEach((event: Event) => {
            if (this.listingsWrapper) {
                this.listingsWrapper.append(this.createListing({
                    venueName: event.venue.name,
                    venueCity: event.venue.city,
                    venueStreet: event.venue.street_address,
                    venueCountry: event.venue.country,
                    date: event.datetime,
                    url: event.url,
                    ticket: event.offers[0]?.url
                }));
            }
        });
    }

    createListing(event: ListingEvent): HTMLElement {
        const el = document.createElement('li');
        el.innerHTML = `
            <div>${moment(event.date).format('MMM')} ${moment(event.date).format('DD')}</div>
            <div>${event.venueName}</div>
            <div class="country">${event.venueCountry}</div>
            <div>
                ${event.ticket ? `<a href="${event.ticket}" target="_blank"><button>Tickets</button></a>` : ''}
                ${event.url ? `<a href="${event.url}" target="_blank"><button class="info">Info</button></a>` : ''}
            </div>          
        `;
        return el;
    }
}
export default Tour;